import React from 'react'

const DigitalMarkingLanding = () => {
  return (
    <div className="digital-marketing-landing">
        <div className="url_address">
            <h3>Home &gt; </h3>
            <h3>Expertise &gt; </h3>
            <h3>Digital Marketing</h3>
        </div>
        <div className="webdev_landing">
            <div className="left_side">
                <h1>Digital Marketing</h1>
                <h2>Maximizing Your Online Reach through Data-Driven Digital Marketing Strategies.</h2>
                <h3>Our digital marketing services are designed to increase your online visibility, reach, and engagement with your target audience. By leveraging data analytics, industry-proven tactics, and a results-focused approach, we develop personalized marketing strategies that drive real business growth. From search engine optimization and social media advertising to email marketing and content creation, we have the expertise and experience to help you achieve your digital marketing goals.</h3>
            </div>
            <div className="right_side">
                <img src='https://wallpaperaccess.com/cdn-cgi/mirage/25a2673c2a848fb856b414667be76f9e72e69bb92a10df37e075ad59b803adcb/1280/full/6511565.jpg' alt="image" />
            </div>
        </div>
    </div>
  )
}

export default DigitalMarkingLanding